// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes mic-indicator_popIn_F3vg4 {
    from {transform: scale(0.5)}
    to {transform: scale(1)}
}

.mic-indicator_mic-img_s3s9d {
    margin: 10px;
    transform-origin: center;
    animation: mic-indicator_popIn_F3vg4 0.1s ease-in-out;
}
`, "",{"version":3,"sources":["webpack://./src/components/mic-indicator/mic-indicator.css"],"names":[],"mappings":"AAAA;IACI,MAAM,qBAAqB;IAC3B,IAAI,mBAAmB;AAC3B;;AAEA;IACI,YAAY;IACZ,wBAAwB;IACxB,qDAAiC;AACrC","sourcesContent":["@keyframes popIn {\n    from {transform: scale(0.5)}\n    to {transform: scale(1)}\n}\n\n.mic-img {\n    margin: 10px;\n    transform-origin: center;\n    animation: popIn 0.1s ease-in-out;\n}\n"],"sourceRoot":""}]);
// Exports
var _1 = `mic-indicator_mic-img_s3s9d`;
export { _1 as "mic-img" };
export var micImg = `mic-indicator_mic-img_s3s9d`;
export var popIn = `mic-indicator_popIn_F3vg4`;
export default ___CSS_LOADER_EXPORT___;
